// Сурлага — нийтлэг: 1–4 шкал (багшийн дүнгийн хүснэгттэй ижил), өнгө, API
import React from "react";
import { instance } from "utils/axios";

export const LEVELS = ["", "Эхлэл", "Хөгжиж буй", "Хангасан", "Давсан"];
export const levelLabel = (v) => (v == null ? "Үнэлээгүй" : LEVELS[Math.max(1, Math.min(4, Math.round(v)))]);
export const tone = (v) => (v == null ? "bg-gray-100 text-gray-500" : v >= 3.5 ? "bg-emerald-50 text-emerald-700" : v >= 2.5 ? "bg-sky-50 text-sky-800" : v >= 1.5 ? "bg-amber-50 text-amber-800" : "bg-red-50 text-red-700");
export const MARK = { TBL: "Хараахан үнэлээгүй", NE: "Ажил ирүүлээгүй" };
export const BEHAV = { participation: "Оролцоо", attitude: "Хандлага", performance: "Гүйцэтгэл" };
export const get = (url, params) => instance({ method: "get", url, params, silent: true }).then((r) => r.data);
// who: "me" (сурагч) эсвэл хүүхдийн id (эцэг эх)
export const base = (who) => `/student/learning/${who}`;
export const qs = (who, termId) => new URLSearchParams({ ...(who !== "me" ? { s: who } : {}), ...(termId ? { t: termId } : {}) }).toString();

export const Dots = ({ v }) => (
  <span className="inline-flex gap-1 shrink-0" aria-label={`${v}/4`}>{[1, 2, 3, 4].map((i) => <span key={i} className={`h-2 w-4 rounded-full ${i <= v ? "bg-primary" : "bg-[#e5d8f5]"}`} />)}</span>
);

export function LevelBadge({ v, big = false }) {
  return (
    <span className={`shrink-0 rounded-xl text-center ${big ? "px-4 py-2" : "px-2.5 py-1"} ${tone(v)}`}>
      <span className={`block font-extrabold tabular-nums leading-none ${big ? "text-3xl" : "text-lg"}`}>{v == null ? "—" : v.toFixed(1)}</span>
      <span className="block text-[10px] font-semibold mt-0.5">{levelLabel(v)}</span>
    </span>
  );
}

export function TermChips({ terms, value, onChange }) {
  if (!terms || terms.length < 2) return null;
  return (
    <div className="flex gap-2 flex-wrap">
      {terms.map((t) => (
        <button key={t.id} type="button" onClick={() => onChange(t.id)} aria-pressed={t.id === value}
          className={`h-8 px-3.5 rounded-full text-sm font-bold border ${t.id === value ? "bg-primary text-white border-primary" : "bg-white text-gray-700 border-gray-200"}`}>{t.name}</button>
      ))}
    </div>
  );
}
